import React from "react";
import { FaArrowRight, FaBuilding, FaCheckCircle, FaRoute } from "react-icons/fa";
import styled from "styled-components";
import { BREAKPOINTS } from "../../styles/variables";

const TeaserSection = styled.section`
  padding: 34px 0 18px;
  background: transparent;
`;

const Container = styled.div`
  width: min(1160px, calc(100% - 32px));
  margin: 0 auto;
`;

const Card = styled.article`
  display: grid;
  gap: 26px;
  align-items: center;
  padding: 24px;
  border: 1px solid rgba(14, 51, 134, 0.1);
  border-radius: 30px;
  background:
    radial-gradient(circle at 90% 10%, rgba(84, 214, 154, 0.16), transparent 34%),
    linear-gradient(135deg, #07111f 0%, #10213a 100%);
  box-shadow: 0 24px 80px rgba(7, 17, 31, 0.15);
  color: white;

  @media (min-width: ${BREAKPOINTS.DESKTOP}) {
    grid-template-columns: 0.9fr 1.1fr auto;
    padding: 30px;
  }
`;

const Label = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 14px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  svg {
    color: #78e6b0;
  }
`;

const Title = styled.h2`
  max-width: 560px;
  margin: 0;
  color: white;
  font-size: clamp(28px, 4vw, 42px);
  line-height: 1.02;
  letter-spacing: -0.055em;
`;

const Copy = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.66);
  font-size: 16px;
  line-height: 1.65;
`;

const ProofList = styled.div`
  display: grid;
  gap: 10px;
`;

const ProofItem = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  color: rgba(255, 255, 255, 0.76);
  font-size: 14px;
  font-weight: 700;

  svg {
    color: #78e6b0;
    flex: 0 0 auto;
  }
`;

const Action = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 52px;
  padding: 0 20px;
  border-radius: 999px;
  background: #ffffff;
  color: #07111f;
  font-weight: 900;
  white-space: nowrap;

  &:hover {
    color: #07111f;
    transform: translateY(-1px);
  }
`;

const EnterprisePilotTeaser = () => (
  <TeaserSection aria-label="Pilotos B2B Trineo">
    <Container>
      <Card>
        <div>
          <Label>
            <FaBuilding /> Trineo para empresas
          </Label>
          <Title>Pilotos B2B para operaciones que necesitan más control.</Title>
        </div>
        <div>
          <Copy>
            Estamos invitando a empresas seleccionadas a validar una control tower logística con
            solicitudes, asignación, tracking, app transportista, POD y webhooks sobre operación real.
          </Copy>
          <ProofList>
            <ProofItem>
              <FaCheckCircle /> Implementación acompañada, no self-service masivo.
            </ProofItem>
            <ProofItem>
              <FaRoute /> Flujo operativo completo antes de escalar.
            </ProofItem>
          </ProofList>
        </div>
        <Action href="/empresas">
          Ver pilotos B2B <FaArrowRight />
        </Action>
      </Card>
    </Container>
  </TeaserSection>
);

export default EnterprisePilotTeaser;